/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportExerciseDTO
 */
export interface SupportExerciseDTO {
    /**
     * 
     * @type {string}
     * @memberof SupportExerciseDTO
     */
    exerciseId: string;
    /**
     * 
     * @type {string}
     * @memberof SupportExerciseDTO
     */
    description?: string;
}

/**
 * Check if a given object implements the SupportExerciseDTO interface.
 */
export function instanceOfSupportExerciseDTO(value: object): value is SupportExerciseDTO {
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    return true;
}

export function SupportExerciseDTOFromJSON(json: any): SupportExerciseDTO {
    return SupportExerciseDTOFromJSONTyped(json, false);
}

export function SupportExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'exerciseId': json['exerciseId'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function SupportExerciseDTOToJSON(json: any): SupportExerciseDTO {
    return SupportExerciseDTOToJSONTyped(json, false);
}

export function SupportExerciseDTOToJSONTyped(value?: SupportExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exerciseId': value['exerciseId'],
        'description': value['description'],
    };
}

